export interface MixpanelConfig {
  token: string
  debug?: boolean
  track_pageview?: boolean
  ignore_dnt?: boolean
  persistence?: 'localStorage' | 'cookie'
  api_host?: string
}

export interface UserProfile {
  id: string
  email?: string
  name?: string
  companyId?: string
  companyName?: string
  role?: string
  permissions?: string[]
  createdAt?: string
  plan?: string
}

export interface TrackingProperties {
  [key: string]: any
}

export enum EventCategory {
  Authentication = 'Authentication',
  Navigation = 'Navigation',
  Experience = 'Experience',
  Order = 'Order',
  Payment = 'Payment',
  User = 'User',
  Company = 'Company',
  Store = 'Store',
  Product = 'Product',
  Search = 'Search',
  Error = 'Error',
}

export enum EventName {
  // Authentication Events
  Login = 'Login',
  Logout = 'Logout',
  SignUp = 'Sign Up',
  PasswordReset = 'Password Reset',

  // Navigation Events
  PageView = 'Page View',

  // Experience Events
  ExperienceView = 'Experience View',
  ExperienceCreate = 'Experience Create',
  ExperienceEdit = 'Experience Edit',
  ExperienceDelete = 'Experience Delete',
  ExperienceArchive = 'Experience Archive',
  ExperienceBook = 'Experience Book',

  // Order Events
  OrderCreate = 'Order Create',
  OrderView = 'Order View',
  OrderCancel = 'Order Cancel',
  OrderComplete = 'Order Complete',
  OrderValidate = 'Order Validate',
  CartAdd = 'Add to Cart',
  CartRemove = 'Remove from Cart',
  CartView = 'Cart View',
  CartExpire = 'Cart Expire',
  CartAbandonment = 'Cart Abandonment',
  CheckoutStart = 'Checkout Start',
  CheckoutComplete = 'Checkout Complete',
  BookingInitiated = 'Booking Initiated',

  // Payment Events
  PaymentStart = 'Payment Start',
  PaymentSubmit = 'Payment Submit',
  PaymentSuccess = 'Payment Success',
  PaymentFailed = 'Payment Failed',
  PaymentElementReady = 'Payment Element Ready',

  // User Events
  UserCreate = 'User Create',
  UserEdit = 'User Edit',
  UserDelete = 'User Delete',

  // Company Events
  CompanyCreate = 'Company Create',
  CompanyEdit = 'Company Edit',
  CompanySwitch = 'Company Switch',

  // Store Events
  StoreCreate = 'Store Create',
  StoreEdit = 'Store Edit',
  StoreDelete = 'Store Delete',
  WidgetCreate = 'Widget Create',
  WidgetEdit = 'Widget Edit',

  // Product Events
  ProductCreate = 'Product Create',
  ProductEdit = 'Product Edit',
  ProductDelete = 'Product Delete',
  InventoryUpdate = 'Inventory Update',

  // Search Events
  Search = 'Search',
  FilterApply = 'Filter Apply',

  // Error Events
  ErrorOccurred = 'Error Occurred',
  ApiError = 'API Error',
}

export interface TrackingEvent {
  name: EventName
  category: EventCategory
  properties?: TrackingProperties
}

export interface PageViewProperties extends TrackingProperties {
  page: string
  title?: string
  referrer?: string
  locale?: string
}

export interface OrderProperties extends TrackingProperties {
  orderId: string
  orderUid?: string
  amount?: number
  currency?: string
  experienceId?: string
  experienceName?: string
  quantity?: number
  customerId?: string
  customerEmail?: string
  paymentMethod?: string
  isFree?: boolean
  revenue?: number
  itemCount?: number
}

export interface ExperienceProperties extends TrackingProperties {
  experienceId: string
  experienceUuid?: string
  experienceName?: string
  category?: string
  price?: number
  currency?: string
  organizer?: string
  location?: string
  duration?: number
  tags?: string[]
  isFree?: boolean
}

export interface ErrorProperties extends TrackingProperties {
  errorMessage: string
  errorCode?: string | number
  errorStack?: string
  url?: string
  component?: string
}

export interface SearchProperties extends TrackingProperties {
  query: string
  resultsCount?: number
  filters?: Record<string, any>
  searchType?: string
}
